export default __webpack_public_path__ + "static/media/map-marker.2288d97b.svg";